export default __webpack_public_path__ + "998c285adfd8481d8b663839e014731a.png";